import React from 'react'
import PropTypes from 'prop-types'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'

export default function HelpBubble ({children, content, position}) {
  return <CustomTooltip tooltipPosition={position} toolTipText={content}>
    <i className='fa fa-question' />
  </CustomTooltip>
}

HelpBubble.propTypes = {
  position: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
}

HelpBubble.defaultProps = {
  position: 'bottom'
}



// WEBPACK FOOTER //
// ./src/components/common/HelpBubble/HelpBubble.js